<div class="login-recovery-options">
  <div class="login-recovery-options__header">
    <div class="login-recovery-options__icon-background">
      <i class="fa-regular fa-lock login-recovery-options__icon"></i>
    </div>
    <div class="login-recovery-options__header-title">{{ 'login.options.forgot-credentials' | translate }}</div>
  </div>

  <div class="login-recovery-options__links">
    @for (option of loginRecoveryOptions; track option.loginRecoveryPath) {
      <div class="login-recovery-options__link">
        <itc-login-recovery-option
          [iconClassName]="option.iconClassName"
          [label]="option.labelTranslationKey | translate"
          [loginRecoveryPath]="option.loginRecoveryPath"
        />
      </div>
    }
  </div>

  <div class="login-recovery-options__button">
    <kds-large-button
      colorScheme="tertiary"
      [buttonText]="'login.recovery.buttons.back-to-login' | translate"
      (buttonClick)="backToLogin()"
    />
  </div>
</div>
